import { render, staticRenderFns } from "./SancionesDialog.vue?vue&type=template&id=6871356a"
import script from "./SancionesDialog.vue?vue&type=script&lang=js"
export * from "./SancionesDialog.vue?vue&type=script&lang=js"
import style0 from "./SancionesDialog.vue?vue&type=style&index=0&id=6871356a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports